<template>
	<div>
		<div class="card mb-4">
            <div class="card-header">
		    	<div class="d-flex justify-content-between container-fluid">
		            <div class="text-muted fs-19">
		            	<strong>Informações</strong>
		            </div>
			    </div>
		    </div>
		    <div class="card-body">
		    	<div class="container-fluid">
		    		<div class="row">
		    			<div class="col-md-6">
		    				<div class="text-muted fs-17 mb-2 ml-2">
				            	<strong>Entrega</strong>
				            </div>
		    				<ul class="list-group">
								<li class="list-group-item d-flex justify-content-between teste">
									<div>
										<strong>#</strong>
									</div>
									<div>
										{{ dados.id }}
									</div>
								</li>
                                <li class="list-group-item d-flex justify-content-between">
									<div>
										<strong>Data</strong>
									</div>
									<div>
										{{ dados.data_br }}
									</div>
								</li>
							</ul>
		    			</div>
		    			<div class="col-md-6">
		    				<div class="text-muted fs-17 mb-2 ml-2">
				            	<strong>Valores</strong>
				            </div>
		    				<ul class="list-group">
		    					<li class="list-group-item d-flex justify-content-between">
									<div>
										<strong>Total destinos</strong>
									</div>
									<div>
                                        {{ dados.total_destinos }}
									</div>
								</li>
                                <li class="list-group-item d-flex justify-content-between" v-if="dados.finalizado_at">
									<div>
										<strong>Finalizado em</strong>
									</div>
									<div>
										{{ dados.finalizado_at_br }}
									</div>
								</li>
		    				</ul>
		    			</div>
		    		</div>
				</div>
		    </div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['dados'],
	}
</script>

<style scoped>
	.pointer {
		cursor: pointer;
	}
	.close-tag {
		border-radius: 50px;
		background-color: red;
		padding-left: 3px;
		padding-right: 3px;
		padding-top: 1px;
		padding-bottom: 1px;
		margin-left: 10px;
		position: relative;
		display: none;
	}
	.close-tag:hover {
		font-size: 15px;
	}
	.badge-pill:hover .close-tag {
		display: block;
	}
</style>
